var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "white",
    id: "Layer_1",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: "{4}"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.567,183.652l54.978-54.978c7.681-7.68,6.083-20.543-3.217-26.121L331.371,2.379 c-6.568-3.941-14.978-2.905-20.395,2.511L256,59.867L201.022,4.89c-5.416-5.415-13.825-6.453-20.395-2.511L13.67,102.553 c-9.316,5.589-10.882,18.456-3.216,26.122l54.978,54.977l-54.977,54.978c-7.681,7.68-6.084,20.543,3.216,26.122l58.676,35.206 v95.173c0,5.865,3.078,11.299,8.106,14.316L247.41,509.62c5.278,3.167,11.882,3.179,17.18,0l166.957-100.174 c5.028-3.017,8.105-8.451,8.105-14.316v-95.173l58.676-35.206c9.316-5.589,10.882-18.456,3.216-26.122L446.567,183.652z M325.371,37.717l137.442,82.466l-42.445,42.445c-5.922-3.553-131.682-79.009-137.442-82.466L325.371,37.717z M390.505,183.652 L256,264.355l-134.506-80.703L256,102.948L390.505,183.652z M49.187,120.185l137.442-82.467l42.445,42.445 c-5.758,3.455-131.523,78.915-137.442,82.466L49.187,120.185z M49.186,247.119l42.445-42.444 c5.923,3.553,131.682,79.009,137.442,82.466l-42.445,42.445L49.186,247.119z M406.26,385.677L256,475.833l-150.372-90.156v-65.685 l75,44.934c6.569,3.941,14.978,2.905,20.395-2.511L256,307.437l54.978,54.978c5.422,5.422,13.833,6.449,20.395,2.511 l74.888-44.934V385.677z M325.37,329.585l-42.445-42.445c5.758-3.455,131.523-78.915,137.442-82.467l42.445,42.445L325.37,329.585 z"
  }), "{\" \"}\n      ")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpen);
export default __webpack_public_path__ + "static/media/BoxOpen.a5c846ec372dfe29472dbc145951beab.svg";
export { ForwardRef as ReactComponent };